module.exports = __webpack_public_path__ + "assets/02a7f15c32ffbd80554304ef9389a01b.mp4";